import * as React from 'react';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputText } from '../../helper/getWidgetInputText';
import { FormItem, Props as FormItemProps } from 'client/ui/form/FormItem';
import { getWidgetInputLayout } from '../../helper/getWidgetInputLayout';
import { getWidgetLayoutFromSetup } from '../../setup/layout/getWidgetLayoutFromSetup';
import classNames from 'classnames';
import { WidgetLayout } from 'common/schema/widget/WidgetLayout';
import './FormWidgetItem.scss';

export interface FormWidgetItemProps extends FormItemProps<any> {
  widget: IWidget;
}

export function FormWidgetItem(props: FormWidgetItemProps) {
  const { widget, ...otherProps } = props;
  const { label, message, placeholder } = getWidgetInputText(widget);
  const layout = getWidgetLayoutFromSetup(widget.input);
  const isLabelEmpty = !label?.trim();

  return (
    <FormItem
      label={isLabelEmpty ? undefined : label}
      colon={!isLabelEmpty}
      {...message}
      {...otherProps}
      {...layout}
      className={classNames('form-widget-item', props.className, {
        'form-item--vertical':
          widget.input?.extra?.layout === WidgetLayout.Vertical
      })}
    >
      {props.children}
    </FormItem>
  );
}
